import { css } from '@emotion/css';

export const CORRECT_OPTION_BACKGROUND_COLOR = '#52b68d';
export const CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR = '#3a9f76';
const INCORRECT_OPTION_BACKGROUND_COLOR = '#dc2c50';
export const INCORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR = '#b92140';
export const PARTIALLY_CORRECT_OPTION_BACKGROUND_COLOR = '#fbbf24';
export const PARTIALLY_CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR = '#f59e0b';

export const correctOptionKeyCodeBackground = css`
  background-color: ${CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
`;

export const correctOptionItemBackground = css`
  background-color: ${CORRECT_OPTION_BACKGROUND_COLOR};
`;

export const correctOptionItemBorder = css`
  border-color: ${CORRECT_OPTION_BACKGROUND_COLOR};

  &.disabled {
    border-color: ${CORRECT_OPTION_BACKGROUND_COLOR}80;
  }
`;

export const incorrectOptionKeyCodeBackground = css`
  background-color: ${INCORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
`;

export const incorrectOptionItemBackground = css`
  background-color: ${INCORRECT_OPTION_BACKGROUND_COLOR};
`;

export const incorrectOptionItemBorder = css`
  border-color: ${INCORRECT_OPTION_BACKGROUND_COLOR};
`;

export const partiallyCorrectOptionKeyCodeBackground = css`
  background-color: ${PARTIALLY_CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
`;

export const partiallyCorrectOptionItemBackground = css`
  background-color: ${PARTIALLY_CORRECT_OPTION_BACKGROUND_COLOR};
`;

export const partiallyCorrectOptionItemBorder = css`
  border-color: ${PARTIALLY_CORRECT_OPTION_BACKGROUND_COLOR};
`;

export const attachmentGridStyles = css`
  grid-template-columns: repeat(auto-fit, minmax(9.6rem, 1fr));
  grid-template-rows: repeat(auto-fit, 19.2rem);

  .GRID {
    margin: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const maxH298 = css`
  max-height: 29.8rem;
`;

export const h195 = css`
  height: 19.5rem;
`;

export const optionCodeStyles = (
  optionTextColor?: string,
  secondaryBackgroundColor?: string,
) => css`
  pre {
    ${secondaryBackgroundColor ? `background: ${secondaryBackgroundColor} !important` : ''};
    ${optionTextColor ? `color: var(--${optionTextColor})` : ''};
    border-radius: 0.8rem;
    padding: 0.8rem 1.6rem;

    code {
      white-space: pre-wrap;
    }
  }

  .code-01 {
    ${secondaryBackgroundColor ? `background: ${secondaryBackgroundColor} !important` : ''};
    ${optionTextColor ? `color: var(--${optionTextColor})` : ''};
    border: none;
  }
`;
